// extracted by mini-css-extract-plugin
export default {"imageWrapper":"MF-z","hovered":"NF-z","hoverImage":"OF-z","mainImage":"PF-z","imageNoBackground":"QF-z","fullSizeImage":"RF-z"};